import InfoMessageBlock from '~/components/InfoMessageBlock.jsx';

const EditHiddenForm = ({ settings, setSettings, question, url, label }) => {
    const fieldKey = encodeURIComponent(label) || `answer[${question.id}]`;
    const prefilledUrl = url + `?${fieldKey}=VALUE`;

    return (
        <div>
            <div className="text-sm text-gray-500 mx-4 mt-1">
                Field ID: <strong>{fieldKey}</strong>
            </div>
            <InfoMessageBlock className="mt-4">
                <div>
                    This is a hidden field, it won't show to clients but you can
                    use it to pass information into the form via the URL for
                    tracking. This is an advanced feature.
                </div>

                <div className="mt-4">
                    Append the parameter <strong>?{fieldKey}</strong> replacing
                    <strong> VALUE</strong> with your information, as seen
                    below:
                </div>
                <div className="font-mono  mt-2 rounded-lg p-4 bg-blue-100">
                    {prefilledUrl}
                </div>
            </InfoMessageBlock>
        </div>
    );
};

export default EditHiddenForm;
